module.exports = __webpack_public_path__ + "static/media/inchera.99755e48.png";